<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
<!--                        {{ $t('message.add') }} {{ $tc('message.obstetricParameters', 1) }}-->
                        {{ $t('message.add') }} {{ $t('message.parameter') }}

                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="p-1em">
                    <h3 class="card-title text-center mb-0">
                        {{prenatalConsultationInformation}}
                    </h3>
                </div>
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="4">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="weight-group"
                                        :label="$t('message.weight')"
                                        label-for="weight"
                                        description=""
                                >
                                    <b-form-input
                                            id="weight"
                                            v-model="$v.form.weight.$model"
                                            :state="$v.form.weight.$dirty ? !$v.form.weight.$error : null"
                                            type="number"
                                            required
                                            placeholder=""
                                            @keydown="clearErrorField('poids')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="$v.form.weight.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('poids')" style="color:red">
                                    {{getErrorsField('poids')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="taSystolique-group"
                                        :label="$t('message.taSystolique')"
                                        label-for="taSystolique">
                                    <b-form-input
                                            id="taSystolique"
                                            v-model="$v.form.taSystolique.$model"
                                            :state="$v.form.taSystolique.$dirty ? !$v.form.taSystolique.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('ta_systolique')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ta_systolique')" style="color:red">
                                    {{getErrorsField('ta_systolique')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="taDiastolique-group"
                                        :label="$t('message.taDiastolique')"
                                        label-for="taDiastolique">
                                    <b-form-input
                                            id="taDiastolique"
                                            v-model="$v.form.taDiastolique.$model"
                                            :state="$v.form.taDiastolique.$dirty ? !$v.form.taDiastolique.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('ta_diastolique')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('ta_diastolique')" style="color:red">
                                    {{getErrorsField('ta_diastolique')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group
                                        id="urineHeight-group"
                                        :label="$t('message.urineHeight')"
                                        label-for="urineHeight"
                                        description=""
                                >
                                    <b-form-input
                                            id="urineHeight"
                                            v-model="$v.form.urineHeight.$model"
                                            :state="$v.form.urineHeight.$dirty ? !$v.form.urineHeight.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('hauteur_urine')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('hauteur_urine')" style="color:red">
                                    {{getErrorsField('hauteur_urine')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="touchVaginal-group"
                                        :label="$t('message.touchVaginal')"
                                        label-for="touchVaginal"
                                        description=""
                                >
                                    <b-form-input
                                            id="touchVaginal"
                                            v-model="$v.form.touchVaginal.$model"
                                            :state="$v.form.touchVaginal.$dirty ? !$v.form.touchVaginal.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('toucher_vaginal')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('toucher_vaginal')" style="color:red">
                                    {{getErrorsField('toucher_vaginal')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="heartNoise-group"
                                        :label="$t('message.heartNoise')"
                                        label-for="heartNoise-group"
                                        description=""
                                >
                                    <b-form-input
                                            id="heartNoise"
                                            v-model="$v.form.heartNoise.$model"
                                            :state="$v.form.heartNoise.$dirty ? !$v.form.heartNoise.$error : null"
                                            type="number"
                                            @keydown="clearErrorField('bruit_du_coeur')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('bruit_du_coeur')" style="color:red">
                                    {{getErrorsField('bruit_du_coeur')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">

                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import { mapGetters } from 'vuex';

    export default {
        name: "AddObstetric",
        computed: {
            ...mapGetters(["obstParameterPrenatalConsultation",'errors',"hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            prenatalConsultationInformation:function(){
                if (typeof (this.obstParameterPrenatalConsultation.user) == 'object') {
                    let user = this.obstParameterPrenatalConsultation.user;
                    let prenom = (user.prenom != null ? user.prenom : '');
                    prenom =  prenom.toLowerCase();
                    let fullName =  ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    return fullName + " - " + this.obstParameterPrenatalConsultation.type_de_consultation;
                }else
                return  "";
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole|| this.hasAssistante;
                }
            }
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    weight:"",
                    taSystolique:"",
                    taDiastolique:"",
                    urineHeight:"",
                    touchVaginal:"",
                    heartNoise:"",
                },
                show: true
            }
        },

        methods: {
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_prenatale_id: this.obstParameterPrenatalConsultation.id,
                        poids:this.form.weight,
                        ta_systolique:this.form.taSystolique,
                        ta_diastolique:this.form.taDiastolique,
                        hauteur_urine:this.form.urineHeight,
                        toucher_vaginal:this.form.touchVaginal,
                        bruit_du_coeur:this.form.heartNoise,
                    };

                    let successMessage = this.$i18n.t('message.obstetricParameterCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createObstetricParameter', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                // evt.preventDefault();
                //
                // // Reset our form values
                // this.form.weight = '';
                // this.form.taDiastolique = '';
                // this.form.taDiastolique = '';
                // this.form.urineHeight = '';
                // this.form.touchVaginal = '';
                // this.form.heartNoise = '';
                //
                // // Trick to reset/clear native browser form validation state
                // this.show = false;
                //
                // this.$nextTick(() => {
                //     this.show = true;
                // });
            },

            getObstetricParameters() {
                let args = {
                    consultation: this.consultation_id,
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getObstParameterPrenatalConsultation', { args : args });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },
        validations: {
            form: {
                weight: {
                    required
                },
                taDiastolique: {
                    //
                },
                taSystolique: {
                    //
                },
                urineHeight: {
                    //
                },
                touchVaginal: {
                    //
                },
                heartNoise: {
                    //
                }
            }
        },
        mounted() {
            // Fetch ultrasound list
            this.getObstetricParameters();
        }
    }
</script>

<style scoped>

</style>